import * as MutationTypes from './mutation-types'
import ExameService from '@/services/exames-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  state: {
    exames: null,
    exameDocumento: null,
    examsFilter: null,
    laudo: null,
    anexo: null
  },

  getters: {
    exameDocumento: (state) => state.exameDocumento,
    exames: (state) => state.exames,
    examsFilter: (state) => state.examsFilter,
    laudo: (state) => state.laudo,
    anexo: (state) => state.anexo
  },

  mutations: {
    [MutationTypes.SET_EXAMES] (state, value) {
      state.exames = value
    },
    [MutationTypes.SET_EXAME_DOCUMENTO] (state, value) {
      state.exameDocumento = value
    },
    [MutationTypes.SET_EXAMES_FILTROS] (state, value) {
      state.examsFilter = value
    },
    [MutationTypes.SET_EXAME_LAUDO] (state, value) {
      state.laudo = value
    },
    [MutationTypes.SET_EXAME_ANEXO] (state, value) {
      state.anexo = value
    }
  },

  actions: {
    async getArquivoExame ({ commit }, payload) {
      commit('setLoadingState', true)
      await ExameService.getArquivoExame(payload)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((arquivo) => {
          commit(MutationTypes.SET_EXAME_DOCUMENTO, arquivo)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },

    async getExames ({ commit }, datas) {
      commit('setLoadingState', true)
      await ExameService.getExames(datas)
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_EXAMES, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },

    async getExamFilterData ({ commit }) {
      commit('setLoadingState', true)
      await ExameService.getFilterExam()
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.SET_EXAMES_FILTROS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },

    async getLaudoPdf ({ commit }, dados) {
      commit('setLoadingState', true)
      await ExameService.getArquivoLaudo(dados)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((arquivo) => {
          commit(MutationTypes.SET_EXAME_LAUDO, arquivo)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },

    async getAnexo ({ commit }, dados) {
      commit('setLoadingState', true)
      await ExameService.getAnexo(dados.codigoAnexo, dados.codigoItemAtendimento)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((arquivo) => {
          commit(MutationTypes.SET_EXAME_ANEXO, arquivo)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },

    async solicitarImagens ({ commit }, codigoItemAtendimento) {
      commit('setLoadingState', true)
      await ExameService.solicitarImagens(codigoItemAtendimento)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    }
  }
}
